import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import type { IUpdateGroupRequest, IUpdateGroupResponse, IGroup } from 'src/services/api/groups';
import { useNotifications } from 'src/notifications';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { GET_GROUPS_PATH } from 'src/services/api/groups/constants';

export const useUpdateGroup = (id?: number) => {
    const queryClient = useQueryClient();
    const { addNotification } = useNotifications();

    return useMutation<
        IGroup,
        IStandardErrorResponse,
        IUpdateGroupRequest
    >(
        async (payload) => {
            const path = `${GET_GROUPS_PATH}/${id}`;
            const res = await apiClient(path, {
                method: 'patch',
                json: payload,
            }).json<IUpdateGroupResponse>();

            return res.group;
        }, {
            onSuccess: (data) => {
                addNotification('Group updated', 'success');

                queryClient.setQueryData<IGroup[]>(queryKeys.groups, (oldData) => {
                    if (!oldData) {
                        return [];
                    }

                    return oldData.map((group) => {
                        return group.id === data.id ? data : group;
                    });
                });

                queryClient.setQueryData<IGroup>([queryKeys.groups, data.id], data);
            },
        });
};